export function defaultGetOptionId(option: any): string | number {
  return typeof option?.id === 'string' || typeof option?.id === 'number' ? option.id : ''
}

export function defaultGetOptionName(option: any): string {
  return typeof option?.name === 'string' ? option.name : ''
}

export const defaultLoadingMessage = 'Загрузка...'
export const defaultNoOptionsMessage = 'Значения нет в справочнике. Возможно, вы ошиблись в написании.'
export const defaultNoOptionsMessageWithEmptySearch = 'Значения не найдены'
